import { render, staticRenderFns } from "./SettingsSystemStatus.vue?vue&type=template&id=bc5a28bc"
import script from "./SettingsSystemStatus.vue?vue&type=script&lang=js"
export * from "./SettingsSystemStatus.vue?vue&type=script&lang=js"
import style0 from "./SettingsSystemStatus.vue?vue&type=style&index=0&id=bc5a28bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports